import { useCallback, useEffect, useRef, useState } from "react";
import CourseCardComponentB2c from "./CourseCardComponentB2c";
import FilterAndSearchSection from "./FilterAndSearchSection";
import _ from "lodash";
import useLogin from "../../custom-hooks/useLogin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCategoryListNew, getProductCategories, getProductCategoriesData } from "../../redux/courses/actions";
import { SessionKeys, convertHoursToMins, convertTimeFormat, getFormatCourseListFromWoo } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import CourseCardOneB2C from "./CourseCardOneB2C";
import ShimmerScreen from "../Layouts/ShimmerScreen";

const CourseComboMainComponent = (props) => {
    const { isAllCourse, isMyCourse,isCombo, isFilterShow, tabKey } = props

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoggedIn, userData } = useLogin()
    const observer = useRef();

    useEffect(() => {
        window.scrollTo(0,0);
        return () => {
            
        };
    }, []);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const c = params.get("c");
    let providerId="";
    if(c)
    {
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
 providerId = paramsReq.provider_id;
    }
    // const providerId = params.get("provider_id");
    const tab = params.get("tab");

    const authBroker = useSelector((state) => state.auth.authBroker);
    var productCategoriesDataCatRes = useSelector((state) => state.courses.productCategoriesData);
    const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

    const [courseCount, setCourseCount] = useState(0)
    const [pageNum, setPageNum] = useState(0)

    const [isLoading, setIsLoading] = useState(false)
    const [searchText, setSearchText] = useState("");
    const [courseList, setCourseList] = useState([]);
    const [sortBy, setSortBy] = useState(3);
    const [searchedOrNot, setsearchedOrNot] = useState(false);
    const [filterBy, setFilterBy] = useState(0);
    const [sortOption,] = useState([
        { value: 1, label: 'Name (A to Z)' },
        { value: 2, label: 'Name (Z to A)' },
        { value: 3, label: 'New To Old' },
        { value: 4, label: 'Old To New' }
    ])
    const [filterOption,] = useState([
        { value: 1, label: 'All' },
        { value: 4, label: 'Free for you' },
        // { value: 3, label: 'Purchased Courses' },
    ])
    const [selectedIds, setSelectedIds] = useState([])

    const [pageSize, setPageSize] = useState(12)
    const [currentPage, setCurrentPage] = useState(0)
    const [newCardData, setNewCardData] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    const [isFetching, setIsFetching] = useState(false)
    const [hasNoMore, setHasNoMore] = useState(true)
    const [totalRecords, setTotalRecords] = useState(0)

    const [apiListing, setApiListing] = useState([])

    useEffect(() => {
        resetAll()

    }, [authBroker, isAllCourse, isMyCourse,isCombo])

    useEffect(() => {
        resetAll()
        apiCall(1)
    }, [selectedIds, sortBy, filterBy, searchedOrNot])


    useEffect(() => {
        // setPageNum(1)
        // console.log("start2")
        // apiCall(1)
        return (() => {
            // dispatch(getProductCategoriesClear())
            // dispatch(getProductCategoriesDataClear())
            console.log('return')
            resetAll()
            // setPageNum(0)
        })
    }, [])
    const resetAll = () => {
        // setIsLoading(true)
        setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA)
        setIsFetching(false)
        setHasNoMore(true)
        setTotalRecords(0)
        setCurrentPage(0)
        setApiListing([])

        setPageNum(1)
    }



    useEffect(() => {
        console.log("start3")
        apiCall(pageNum)
    }, [pageNum])

    // useEffect(()=>{
    //     apiCall(1)
    // },[dispatch, isLoggedIn, authBroker])

    const apiCall = (page) => {
        console.log("CallCourseListApi: ", isLoggedIn, authBroker, selectedIds)
        if (!isLoggedIn || !_.isEmpty(authBroker)) {
            getCategoriesData(page);
        }
    }

    const getCategoriesData = (pageNum) => {
        setIsLoading(true)
        console.log('pageNumInReqApiCall1: ', pageNum, currentPage)
        let currentPageTemp = currentPage;
        if (pageNum === 0 || pageNum === 1) {
            setCurrentPage(0)
            currentPageTemp = 0;
        }

        let reqObj = {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            category_id: selectedIds,
            provider_id: providerId ? providerId : '',
            search: searchText,
            sort:sortBy,
            page_size: pageSize,
            page: (currentPageTemp + 1),
        }

        let moduleName = "getProductCategoriesData"
        if (isAllCourse || isCombo) {
            reqObj.brokerage_id = authBroker?.payload?.user?.company_id ? authBroker.payload.user?.company_id : "";
            reqObj.filter = filterBy;
            if(isCombo){
                moduleName = "getComboDataCourse"
            }
        } else if (isMyCourse) {
            moduleName = "getProductCategoriesDataMyCourse"
        }



        console.log('isAllCourse: ', isAllCourse, isMyCourse)
        dispatch(getProductCategoriesData({
            module: moduleName,
            postData: reqObj
        }))
    }

    useEffect(() => {
        console.log('productCategoriesDataCatRes: ', productCategoriesDataCatRes)
        parseCategoryDatRes(productCategoriesDataCatRes)
    }, [productCategoriesDataCatRes])

    const parseCategoryDatRes = (productCategoriesDataCatRes) => {
        if (!_.isEmpty(productCategoriesDataCatRes)) {
            setIsLoading(false)
            if (productCategoriesDataCatRes.status === "success") {
                const categoryData = productCategoriesDataCatRes?.payload?.payload

                if (categoryData?.courseList?.length > 0) {
                    console.log('Sorted', _.sortBy(categoryData?.courseList, 'updated_dt'))
                    let coursesList = categoryData?.courseList;
                    for (let course of coursesList) {

                        // let coursesData = formatWooCourses(data)
                        course.isLock = false;

                        if (course.source === 'broker') {
                            course.is_paid = true;
                            if (course.durationUnit === "Hours") {
                                course.duration = convertHoursToMins(course.duration);
                            }
                            if(course.durationUnit === "Seconds")
                            {
                                course.duration = convertTimeFormat(course.duration,true);
                            }
                            // course.duration = convertTimeFormat(_.toNumber(course.duration));
                            course.durationUnit = "";
                            course.isLock = false;
                        } else {
                            course = getFormatCourseListFromWoo(course, isPremiumUser)
                        }

                    }

                    setTotalRecords(categoryData?.total_record);
                    setCurrentPage(categoryData.page)

                    setCourseList(coursesList);
                } else {
                    setCourseList([]);
                    setCourseCount(0)
                }

            }
        }
    }

    const paginateCB = useCallback((node) => {

        if (isFetching) return

        if (observer.current) observer.current.disconnect()

        observer.current = new IntersectionObserver(entries => {
            console.log("pageNumhasNoMore ", isFetching)
            if (entries[0].isIntersecting && !hasNoMore) {
                setIsFetching(true)
                // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
                setPageNum(pageNum => pageNum + 1)  //pageNum => pageNum + 1
                setNewCardData([...newCardData, ...CONFIG.INITIAL_PRODUCT_CARD_DATA])
            }
        })

        if (node) observer.current.observe(node)
        console.log(node)
    }, [hasNoMore])


    return (<>
        <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <FilterAndSearchSection
                    sectionType={ "public" }
                    entityType={"combo"}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    setsearchedOrNot={setsearchedOrNot}
                    searchedOrNot={searchedOrNot}
                    setFilterBy={setFilterBy}
                    filterBy={filterBy}
                    filterOption={filterOption}
                    setSortBy={setSortBy}
                    sortBy={sortBy}
                    sortOption={sortOption}
                    setSelectedIds={setSelectedIds}
                    isFilterShow={isFilterShow}
                    isLoading={isLoading}
                    tabKey={tabKey} />

                <div className="mgt-3">
                    {isLoading &&  <span className="count-text-head">
                        <ShimmerScreen case="rect" width="10rem" height="2.25rem" /></span>}
                    {!isLoading && courseCount > 0 && <span className="count-text-head">We found {courseCount} learning content for you</span>}

                    <div id = "idCourseList" className="course-listing-box">

                        <CourseCardOneB2C
                            arrList={courseList}
                            newCardData={newCardData}
                            setNewCardData={setNewCardData}
                            setHasNoMore={setHasNoMore}
                            total_records={totalRecords}
                            paginateCB={paginateCB}
                            setIsFetching={setIsFetching}
                            pageNum={pageNum}
                            setCourseCount={setCourseCount}
                            setCurrentPage={setCurrentPage}
                            apiListing={apiListing}
                            setApiListing={setApiListing}
                            tabKey={tabKey}
                            isCombo={true}
                        />
                    </div>
                </div>

            </div>
            <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
        </div>
    </>)

}
export default CourseComboMainComponent;